export default {
  label: {
    greeting: 'Hola',
    login: 'Ingresar',
    item: {
      config: 'Configuraciones',
      createComponent: 'Crear componente',
      exit: 'Salir',
    },
  },
};
